import { render, staticRenderFns } from "./VDataTableCustomHeaderFiltersText.vue?vue&type=template&id=5ee6b2ce&scoped=true"
import script from "./VDataTableCustomHeaderFiltersText.vue?vue&type=script&lang=js"
export * from "./VDataTableCustomHeaderFiltersText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee6b2ce",
  null
  
)

export default component.exports